const labels = {
  scheduled: "Programmato",
  in_progress: "In corso",
  completed: "Completato",
  cancelled: "Annullato",
} as const;

export function StatusBadge({ status }: { status: keyof typeof labels }) {
  return <span className={`status-badge status-badge--${status}`}>{labels[status]}</span>;
}
